import React from 'react';
import {Grid, makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    grid: {
        marginTop: theme.spacing(1),
    },
    cell: {
        padding: theme.spacing(0, 0.5),
    },
    image: {
        width: '140px',
        maxWidth: '100%',
        display: 'block',
        // height: 'auto',
    },
}));

const StoreLinks = () => {
    const classes = useStyles();

    return (
        <Grid container justifyContent="center" alignItems="center" className={classes.grid}>
            <Grid item xs={6} sm={4} container justifyContent="center" alignItems="center" className={classes.cell}>
                <a target="_blank" rel="noreferrer"
                   href="https://play.google.com/store/apps/details?id=com.double_rhyme.hoenickf.doppelreim">
                    <img src="/store-links/android-store-link.png" alt="Get it on Google Play" className={classes.image}/>
                </a>
            </Grid>
            <Grid item xs={6} sm={4} container justifyContent="center" alignItems="center" className={classes.cell}>
                <a target="_blank" rel="noreferrer"
                   href="https://itunes.apple.com/de/app/doppelreim/id1197981487?mt=8">
                    <img src="/store-links/ios-store-link.jpg" alt="Download on the App Store" className={classes.image}/>
                </a>
            </Grid>
        </Grid>
    );
};

export default StoreLinks;
